import React, { useState } from "react";
import BaseCard from "../../../components/ui/BaseCard";
import AddEditTaxInformationModal from "./components/AddEditTaxInformationModal";
import { UserType } from "../../../utils/enum";

const AddEditTaxInformation = ({
  readOnly = false,
  australianBusinessNumber,
  gstPercentage,
  foreignContractor,
  refetchMe,
  authRole,
}) => {
  const [isAddEditTaxInformationOpen, setIsAddEditTaxInformationOpen] = useState(false);
  return (
    <BaseCard className="py-2 px-4 sm:px-6 rounded-lg" elevation={1}>
      <div className="bg-light px-4 py-2 mt-2 mb-2 rounded-md flex justify-between items-center">
        <h6 className="text-dark font-normal">Tax Information</h6>
        {!readOnly && (authRole === UserType.FREELANCER || authRole === UserType.ADMIN) && (
          <i
            className="fa-light fa-pencil text-gray-900 cursor-pointer"
            onClick={() => setIsAddEditTaxInformationOpen(true)}
          ></i>
        )}
      </div>
      <div className="px-4">
        {australianBusinessNumber ? (
          <div className="mb-4 mt-6 mr-72">
            <p className="text-sm font-medium text-primary my-4">
              Australian Business Number:{" "}
              <span className="text-[#686868] font-300">{australianBusinessNumber}</span>
            </p>
            {gstPercentage !== null && gstPercentage !== undefined && gstPercentage !== "" && (
              <p className="text-sm font-medium text-primary my-4">
                GST: <span className="text-[#686868] font-300">{gstPercentage}%</span>
              </p>
            )}
            <p className="font-normal text-dark text-sm mb-1.5">Austration Contractor</p>
            <p>
              As per Australian taxation office( ATO)- Any contractor in Australia must have
              registered business to work as contractor. You can be either sole trader, trust or a
              corporate Pty Ltd company. You must provide your ABN ( Australian Business Number) to
              start working on Tech Domain Portal. Tech Domain will be paying contractor under your
              ABN. Contractor will be responsible for their tax or super payment to ATO. Tech Domain
              will not hold/deduct any tax from your payment. 
            </p>
          </div>
        ) : foreignContractor ? (
          <div>
            <p className="font-normal text-dark text-sm mb-1.5">
              Foreign Contractor Acknowledgement
            </p>
            <p className="mb-1">
              I declare that I am exempt from Australian Tax withholding or ABN requirement because:
            </p>

            <div className="ml-2 ml-12">
              <p>1. I am not an Australian Citizen</p>
              <p>
                2. I will be performing all of services outside of Australia for which I will
                receive payment from Tech Domain. 
              </p>
            </div>
          </div>
        ) : (
          // Neither an ABN nor the foreign-contractor declaration is on record. Say so
          // instead of leaving the card blank, which reads as a page that failed to load.
          <p className="my-4 text-[#686868]">No tax information provided.</p>
        )}
      </div>
      {isAddEditTaxInformationOpen &&
        !readOnly &&
        (authRole === UserType.FREELANCER || authRole === UserType.ADMIN) && (
          <AddEditTaxInformationModal
            open={isAddEditTaxInformationOpen}
            close={setIsAddEditTaxInformationOpen}
            australianBusinessNumber={australianBusinessNumber}
            gstPercentage={gstPercentage}
            foreignContractor={foreignContractor}
            refetchMe={refetchMe}
          />
        )}
    </BaseCard>
  );
};

export default AddEditTaxInformation;
